export const customStyles = {
  boxShadow: 'rgba(0, 0, 0, 0.05) 0px 2px 4px',
} as React.CSSProperties;

export default customStyles;
